import React from 'react';
import PropTypes from 'prop-types';

/**
 * Switch component for web
 *
 * Toggle switch for on/off states (settings, preferences, etc.)
 */
const Switch = ({
  label,
  checked = false,
  onChange,
  disabled = false,
  className = '',
  id,
  name,
  ...props
}) => {
  const switchId = id || name || `switch-${label?.replace(/\s+/g, '-').toLowerCase()}`;

  const getSwitchClass = () => {
    if (disabled) {
      return checked ? 'switch-disabled-on' : 'switch-disabled-off';
    }
    return checked ? 'switch-enabled' : 'switch-off';
  };

  return (
    <div className="flex items-center">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={label ? `${switchId}-label` : undefined}
        onClick={() => !disabled && onChange?.(!checked)}
        disabled={disabled}
        className={[
          'switch',
          getSwitchClass(),
          disabled && 'cursor-not-allowed',
          className,
        ].filter(Boolean).join(' ')}
        id={switchId}
        {...props}
      >
        <span
          className={[
            'switch-thumb',
            checked ? 'switch-thumb-on' : 'switch-thumb-off',
          ].join(' ')}
        />
      </button>

      {label && (
        <label
          id={`${switchId}-label`}
          htmlFor={switchId}
          className={[
            'ml-3 text-sm font-medium select-none',
            disabled ? 'text-neutral-400 cursor-not-allowed' : 'text-neutral-700 cursor-pointer',
          ].filter(Boolean).join(' ')}
          onClick={() => !disabled && onChange?.(!checked)}
        >
          {label}
        </label>
      )}
    </div>
  );
};

Switch.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};

export default Switch;
